import { observer } from "mobx-react";
import { IWalletConfigurationOnboardingScreenProps } from "../../wallet-configuration-onboarding-screen";
import OnBoardingScreenTitle from "../../../onboarding-screen-title/onboarding-screen-title";
import { ConfigurationErrorIcon } from "../../icons/configuration-error-icon";
import { Button } from "../../../../../../components/inputs/button/button";
import { BUTTON_VARIANTS } from "../../../../../../components/inputs/button-variants";

const PaymentMethodErrorScreen: React.FC<IWalletConfigurationOnboardingScreenProps> = observer((props) => {
    const { store, getTranslation, scope } = props;
    return (
        <>
            <div className="wallet-configuration-onboarding-screen-title-wrapper">
                <OnBoardingScreenTitle
                    titleText={getTranslation("CONFIGURE_WALLET_ERROR_SCREEN_TITLE",scope)}
                    descriptionText={getTranslation("CONFIGURE_WALLET_ERROR_SCREEN_DESCRIPTION",scope)}
                    maxWidth={550}
                />
            </div>

            <div className="wallet-configuration-onboarding-screen-icon-wrapper">
                <ConfigurationErrorIcon />
                <Button
                    text={getTranslation("CHANGE_PAYMENT_METHOD", scope)}
                    variant={BUTTON_VARIANTS.PrimaryAccent}
                    onClick={store.backToAddingPaymentMethod}
                    hasLoader={true}
                />
            </div>            
        </>
    );
});

export default PaymentMethodErrorScreen;